export class PlayerLocomotionRotate {

    constructor() {
    }
}